import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../../images/logo.svg";
import logoText from "../../../../images/logo-text.svg";

const NavHader = ({noSideBar}) => {
   const [toggle, setToggle] = useState(false);
   return (
      <div className="nav-header">
         <Link to="/" className="brand-logo">
            <img className="logo-abbr" src={process.env.PUBLIC_URL + '/logo/logo.svg'} alt="" />
            <img className="logo-compact" src={process.env.PUBLIC_URL + '/logo/logo-text.svg'} alt="" />
            <img className="brand-title" src={process.env.PUBLIC_URL + '/logo/logo-text.svg'} alt="" />
         </Link>
          {
              noSideBar  ? null : (
                  <div className="nav-control" onClick={() => setToggle(!toggle)}>
                      <div className={`hamburger ${toggle ? "is-active" : ""}`}>
                          <span className="line"></span>
                          <span className="line"></span>
                          <span className="line"></span>
                      </div>
                  </div>
              )
          }

      </div>
   );
};

export default NavHader;
